import { Api } from '@/services/Api'

const rootPath = '/entity'

export default {
  list (pk) {
    return Api().get(`${rootPath}/${pk}/checklist/`)
  },
  checklist_template_items () {
    return Api().get(`${rootPath}/checklist/template-item/`)
  },
  create (pk, data) {
    return Api().post(`${rootPath}/${pk}/checklist/`, data)
  },
  update_items (pk, data) {
    return Api().put(`${rootPath}/checklist/${pk}/item/`, data)
  },
  partial_update (pk, data) {
    return Api().patch(`${rootPath}/checklist/${pk}/`, data)
  },
  delete (pk) {
    return Api().delete(`${rootPath}/checklist/${pk}/`)
  }
}
